import type { SVGProps } from 'react'
const SvgSyTime = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={12} r={8} fillOpacity={0.24} />
		<path d="M12 6.5a.5.5 0 0 0-.5.5v4.75c0 .408.342.75.75.75H15a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5h-2.5V7a.5.5 0 0 0-.5-.5" />
	</svg>
)
export default SvgSyTime
